"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSsoSamlAudienceEndpointForAdfs = exports.getSsoSamlAudienceEndpoint = exports.getSsoSamlAcsEndpoint = exports.getAccountNameIsLoading = exports.getCanSave = exports.getStagedChangesCount = exports.getOpenModal = exports.getOnboardingAccountNamePopoverSeen = exports.getSaveRequestStatus = exports.getUpdateI18nSettingRequestStatus = exports.getFetchCurrencyRequestStatus = exports.getFetchI18nSettingRequestStatus = exports.getFetchI18nOptionsRequestStatus = exports.getAccent2ColorErrorMessage = exports.getAccentColorErrorMessage = exports.getSecondaryColorErrorMessage = exports.getPrimaryColorErrorMessage = exports.getCompanyLogoAltErrorMessage = exports.getCompanyDomainIsValid = exports.getAccountNameIsValid = exports.getAccountName = exports.getRemoveLeadRevisitNotificationsGate = exports.getLeadRevisitNotificationsAccess = exports.getCanEdit = exports.getModuleState = void 0;

var _react = _interopRequireDefault(require("react"));

var _reselect = require("reselect");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _selectors = require("settings-ui-sdk/PortalSettings/selectors");

var _AccountDefaultsActions = require("./actions/AccountDefaultsActions");

var _constants = require("settings-ui-sdk/Hubs/constants");

var _selectors2 = require("settings-ui-sdk/Hubs/selectors");

var _actions = require("settings-ui-sdk/I18n/actions");

var _selectors3 = require("settings-ui-sdk/I18n/selectors");

var _selectors4 = require("settings-ui-sdk/UnifiedBranding/selectors");

var _constants2 = require("settings-ui-sdk/UnifiedBranding/constants");

var _AccessControl = require("./constants/AccessControl");

var _selectors5 = require("settings-ui-sdk/Auth/selectors");

var _constants3 = require("settings-ui-sdk/UserAppAttributes/constants");

var _selectors6 = require("settings-ui-sdk/UserAppAttributes/selectors");

var _Route = require("./constants/Route");

var _Urls = require("./constants/Urls");

var _Domain = _interopRequireDefault(require("PatternValidationJS/patterns/Domain"));

var getModuleState = function getModuleState(state) {
  return state.modules[_Route.ROUTE];
};

exports.getModuleState = getModuleState;
var getCanEdit = (0, _reselect.createSelector)([_selectors5.getUserScopes], function (userScopes) {
  return userScopes.includes(_AccessControl.SCOPES.WRITE);
});
exports.getCanEdit = getCanEdit;
var getLeadRevisitNotificationsAccess = (0, _reselect.createSelector)([_selectors5.getUserScopes, _selectors5.getUserGates], function (scopes, gates) {
  return scopes.indexOf('lead-revisit-notifications-access') !== -1 || gates.indexOf('RA:LeadRevisitGrandfathering') !== -1;
});
exports.getLeadRevisitNotificationsAccess = getLeadRevisitNotificationsAccess;
var getRemoveLeadRevisitNotificationsGate = (0, _reselect.createSelector)([_selectors5.getUserGates], function (gates) {
  return gates.indexOf('LeadRevisits:OneSetting') !== -1;
});
exports.getRemoveLeadRevisitNotificationsGate = getRemoveLeadRevisitNotificationsGate;
var getAccountName = (0, _reselect.createSelector)([_selectors2.getHub], function (hub) {
  return hub.get(_constants.ACCOUNT_NAME);
});
exports.getAccountName = getAccountName;
var getAccountNameIsValid = (0, _reselect.createSelector)([_selectors2.getCurrentHubData, _selectors2.getHub], function (currentHub, hubWithStaging) {
  return hubWithStaging.get(_constants.ACCOUNT_NAME) !== '' && hubWithStaging.get(_constants.ACCOUNT_NAME).length <= _constants.ACCOUNT_NAME_MAX_LENGTH;
});
exports.getAccountNameIsValid = getAccountNameIsValid;
var getCompanyDomainIsValid = (0, _reselect.createSelector)([_selectors4.getCompanyDomain], function (companyDomain) {
  return !companyDomain || _Domain.default.test(companyDomain);
});
exports.getCompanyDomainIsValid = getCompanyDomainIsValid;
var getCompanyLogoAltErrorMessage = (0, _reselect.createSelector)([_selectors4.getCompanyLogoAltText], function (companyLogoAltText) {
  if (companyLogoAltText && companyLogoAltText.length > _constants2.COMPANY_LOGO_ALT_TEXT_MAX_LENGTH) {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "accountdefaults.companyLogoAltText.tooLong"
    });
  }

  return null;
});
exports.getCompanyLogoAltErrorMessage = getCompanyLogoAltErrorMessage;

var isValidHexColor = function isValidHexColor(color) {
  var colorRegex = /#[0-9a-f]{3}([0-9a-f]{3})?$/i;
  return color === '' || Boolean(color.match(colorRegex));
};

var getColorErrorMessage = function getColorErrorMessage(color) {
  if (color && !isValidHexColor(color)) {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "accountdefaults.brandColors.invalidColor"
    });
  }

  return null;
};

var getPrimaryColorErrorMessage = (0, _reselect.createSelector)([_selectors4.getPrimaryColor], function (primaryColor) {
  return getColorErrorMessage(primaryColor);
});
exports.getPrimaryColorErrorMessage = getPrimaryColorErrorMessage;
var getSecondaryColorErrorMessage = (0, _reselect.createSelector)([_selectors4.getSecondaryColor], function (secondaryColor) {
  return getColorErrorMessage(secondaryColor);
});
exports.getSecondaryColorErrorMessage = getSecondaryColorErrorMessage;
var getAccentColorErrorMessage = (0, _reselect.createSelector)([_selectors4.getAccentColor], function (accentColor) {
  return getColorErrorMessage(accentColor);
});
exports.getAccentColorErrorMessage = getAccentColorErrorMessage;
var getAccent2ColorErrorMessage = (0, _reselect.createSelector)([_selectors4.getAccent2Color], function (accent2Color) {
  return getColorErrorMessage(accent2Color);
});
exports.getAccent2ColorErrorMessage = getAccent2ColorErrorMessage;
var FETCH_I18N_OPTIONS = _actions.I18nActionTypes.FETCH_I18N_OPTIONS,
    FETCH_I18N_SETTING = _actions.I18nActionTypes.FETCH_I18N_SETTING,
    UPDATE_I18N_SETTING = _actions.I18nActionTypes.UPDATE_I18N_SETTING;
var getFetchI18nOptionsRequestStatus = (0, _getRequestStatus.default)(FETCH_I18N_OPTIONS);
exports.getFetchI18nOptionsRequestStatus = getFetchI18nOptionsRequestStatus;
var getFetchI18nSettingRequestStatus = (0, _getRequestStatus.default)(FETCH_I18N_SETTING);
exports.getFetchI18nSettingRequestStatus = getFetchI18nSettingRequestStatus;
var getFetchCurrencyRequestStatus = _selectors.getFetchPortalSettingsRequestStatus;
exports.getFetchCurrencyRequestStatus = getFetchCurrencyRequestStatus;
var getUpdateI18nSettingRequestStatus = (0, _getRequestStatus.default)(UPDATE_I18N_SETTING);
exports.getUpdateI18nSettingRequestStatus = getUpdateI18nSettingRequestStatus;
var getSaveRequestStatus = (0, _getRequestStatus.default)(_AccountDefaultsActions.AccountDefaultActionTypes.SAVE_STAGED_CHANGES);
exports.getSaveRequestStatus = getSaveRequestStatus;
var getOnboardingAccountNamePopoverSeen = (0, _selectors6.getOnBoardingItemSeen)(_constants3.SETTINGS_UI_ACCOUNT_NAME_POPOVER_SEEN);
exports.getOnboardingAccountNamePopoverSeen = getOnboardingAccountNamePopoverSeen;
var getOpenModal = (0, _reselect.createSelector)([getModuleState], function (state) {
  return state.interactions;
});
exports.getOpenModal = getOpenModal;
var getStagedChangesCount = (0, _reselect.createSelector)([_selectors2.getStagedChangesCount, _selectors.getStagedChangesCount, _selectors3.getStagedChangesCount, _selectors4.getStagedChangesCount, getOpenModal], function (hubChanges, portalSettingsChanges, languageStagedChanges, brandingStagedChanges, openModal) {
  return openModal !== null ? 0 : [hubChanges, portalSettingsChanges, languageStagedChanges, brandingStagedChanges].reduce(function (acc, val) {
    return acc + val;
  });
});
exports.getStagedChangesCount = getStagedChangesCount;
var getCanSave = (0, _reselect.createSelector)([getAccountNameIsValid, getCompanyDomainIsValid, getCompanyLogoAltErrorMessage, getPrimaryColorErrorMessage, getSecondaryColorErrorMessage, getAccentColorErrorMessage, getAccent2ColorErrorMessage], function (accountNameValid, companyDomainValid, companyLogoAltErrorMessage, primaryColorErrorMessage, secondaryColorErrorMessage, accentColorErrorMessage, accent2ColorErrorMessage) {
  return accountNameValid && companyDomainValid && companyLogoAltErrorMessage === null && primaryColorErrorMessage === null && secondaryColorErrorMessage === null && accentColorErrorMessage === null && accent2ColorErrorMessage === null;
});
exports.getCanSave = getCanSave;
var getAccountNameIsLoading = (0, _reselect.createSelector)([_selectors2.getFetchSuggestedAccountNameRequestStatus, getSaveRequestStatus], function (loadRequestStatus, saveRequestStatus) {
  return loadRequestStatus === _RequestStatusTypes.default.PENDING || saveRequestStatus === _RequestStatusTypes.default.PENDING;
});
exports.getAccountNameIsLoading = getAccountNameIsLoading;
var getSsoSamlAcsEndpoint = (0, _reselect.createSelector)([_selectors5.getPortalId], function (portalId) {
  return _Urls.SSO_SAML_ACS_ENDPOINT + "?portalId=" + portalId;
});
exports.getSsoSamlAcsEndpoint = getSsoSamlAcsEndpoint;
var getSsoSamlAudienceEndpoint = (0, _reselect.createSelector)([_selectors5.getPortalId], function (portalId) {
  return _Urls.SSO_SAML_AUDIENCE_ENDPOINT + "?portalId=" + portalId;
});
exports.getSsoSamlAudienceEndpoint = getSsoSamlAudienceEndpoint;
var getSsoSamlAudienceEndpointForAdfs = (0, _reselect.createSelector)([_selectors5.getPortalId], function (portalId) {
  return _Urls.SSO_SAML_AUDIENCE_ENDPOINT + "/" + portalId;
});
exports.getSsoSamlAudienceEndpointForAdfs = getSsoSamlAudienceEndpointForAdfs;